module.exports = __webpack_public_path__ + "static/img/Orchestral.ed60f51.ed60f513.jpg";